<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	interface Props {
		config: BrandConfig;
		className?: string;
	}

	let { config, className = '' }: Props = $props();
</script>

<div class="contact-section {className}">
	<h2>{config.contactPage?.getInTouch?.title || 'Get in Touch'}</h2>
	<p>
		{config.contactPage?.getInTouch?.description || 'We\'d love to hear from you! Whether you have questions about our services, need support, or want to share feedback, we\'re here to help.'}
	</p>

	<div class="contact-info">
		<div class="contact-item">
			<h3>Email</h3>
			<p>
				<a href="mailto:{config.contactPage?.contactInfo?.email || `hello@${config.brand}`}" class="contact-link">
					{config.contactPage?.contactInfo?.email || `hello@${config.brand}`}
				</a>
			</p>
		</div>
	</div>
</div>

<style>
	.contact-section {
		margin-bottom: 0;
	}

	.contact-section h2 {
		font-size: 1.75rem;
		color: var(--brand-primary);
		margin-bottom: 1.5rem;
	}

	.contact-section p {
		color: #374151;
		line-height: 1.7;
		margin-bottom: 1rem;
	}

	.contact-info {
		margin-top: 1.5rem;
	}

	.contact-item {
		margin-bottom: 1.5rem;
		padding: 1rem;
		background: #f8fafc;
		border-radius: 8px;
		border-left: 4px solid var(--brand-primary);
	}

	.contact-item h3 {
		font-size: 1.25rem;
		color: var(--brand-primary);
		margin-bottom: 0.5rem;
	}

	.contact-item p {
		color: #374151;
		line-height: 1.7;
		margin-bottom: 1rem;
	}

	.contact-link {
		color: var(--brand-primary);
		text-decoration: none;
		font-weight: 600;
	}

	.contact-link:hover {
		color: var(--brand-secondary);
		text-decoration: underline;
	}

	@media (max-width: 768px) {
		.contact-section h2 {
			font-size: 1.5rem;
		}
	}
</style>
